import { sendRequest } from "../../services";
import { apipaths } from "../../services/apiPaths";

export const SectorBoardAction = () => async (dispatch) => {
    const { data: { companies, industries, sector_board } } = await sendRequest(apipaths.sectorBoardList);
    dispatch({ type: "ADD_COMAPNIES", payload: companies });
    dispatch({ type: "ADD_INDUSTRIES", payload: industries });
    dispatch({ type: "ADD_SECTOR_BOARD", payload: sector_board });
}